
import Artyom from "artyom.js";

export function getMona(){

    const Mona = new Artyom();

    

    Mona.addCommands([


        {

            indexes: ['Mona'],
            action: (i) => {
                Mona.say("Yes boss! What can I do for you?");
            }
        },

        {

            indexes: ['Hello', 'Hi', 'is someone there'],
            action: (i) => {
                Mona.say("Hello and how are you?");
            }
        },

        {

            indexes: ['How are you?'],
            action: (i) => {
                Mona.say("I am fine. Thanks for asking");
            }
        },

        {

            indexes: ['Good evening'],
            action: (i) => {
                Mona.say("Good evening to you too");
            }
        },        

    ]);

    Mona.initialize({

        lang: "en-GB",
        continuous: true,
        soundex: true,
        debug: true,
        executionKeyword: "",
        listen: true,
        //name: "Mona"

    }).then( () => {

        Mona.say("Hello My name is Mona. I am an AI powered virtual assistant created by Anna Natalia Komarnicka Emakpor");

        console.log("Mona has been initialized");

    }).catch( (err) => {

        console.log("Mona could not be initialized. The error is "+err);

    });




};
